import React from "react";
import { Entry } from "contentful";
import { BrandInvestmentKeyInitiatives } from "@tiicker/util/lib/contentful/types";
import styles from "./Initiatives.module.scss";

type Props = {
  keyInitiatives: Entry<BrandInvestmentKeyInitiatives>;
};

const Initiatives: React.FC<Props> = ({ keyInitiatives }: Props) => {
  if (!keyInitiatives) return null;

  const { header, headerHex, initiatives } = keyInitiatives.fields;

  return (
    <div className={styles.Initiatives}>
      <h2 className={styles.Initiatives__title} style={{ color: headerHex }}>
        {header}
      </h2>
      <div className={styles.Initiatives__contents}>
        {initiatives.map((initiative, index) => (
          <div className={styles.Initiatives__row} key={index}>
            <img
              src={initiative.fields.bulletImage.fields.file.url}
              alt={initiative.fields.bulletImage.fields.title}
              className={styles.Initiatives__rowImage}
            />
            <div className={styles.Initiatives__rowText}>
              <h4 className={styles.Initiatives__rowTitle}>
                {initiative.fields.title}
              </h4>
              <p className={styles.Initiatives__rowDescription}>
                {initiative.fields.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Initiatives;
